<template>
	<div>
		<h1>Output</h1>

		<p>
			<b>Select sections to include in output</b>
		</p>
		<div style="text-align: center;">
			<Button
				label="Select All"
				@click="selectAll()"
				class="p-mr-2 p-mb-2 btsyleblue"
			/>
			<Button
				label="Deselect All"
				@click="deselectAll()"
				class="p-mr-2 p-mb-2 btsyleblue"
			/>
		</div>

		<div
			v-for="(option, index) of outputOptions"
			:key="index"
			class="p-field-checkbox"
		>
			<Checkbox :id="index" :binary="true" v-model="option.include" />
			<label :for="index">{{ option.label }}</label>
		</div>

		<div class="p-mt-3 p-d-flex p-jc-center">
			<Button class="btsyleblue" label="Generate Output" @click="openModal()" />
		</div>

		<!-- Modal to display output -->
		<Dialog
			header="Methods Section"
			:visible.sync="displayModal"
			:style="{ width: '80vw' }"
			:baseZIndex="2000"
			:modal="true"
		>
			<div id="output">
				<h1>Methods</h1>
				<h2>Study Information</h2>
				<OutputAuditStudyInformation
					v-if="outputOptions[0].include"
					:key="monitorChange"
				/>
				<h2>Study Setting</h2>
				<OutputAuditStudySetting v-if="outputOptions[1].include" :key="monitorChange + 1" />
				<h2>Eligibility Criteria (PICOST)</h2>
				<OutputAuditPicot
					v-if="outputOptions[2].include"
					:key="monitorChange + 2"
					:showAppendix="false"
				/>
				<h2>Sample Size</h2>
				<OutputAuditSampleSize
					v-if="outputOptions[3].include"
					:key="monitorChange + 3"
				/>
				<h2>Recruitment</h2>
				<OutputAuditRecruitment
					v-if="outputOptions[4].include"
					:key="monitorChange + 4"
					:showAppendix="false"
				/>
				<h3>Data Collection, Management and Analysis</h3>
				<OutputAuditDataCollectionManagementAndAnalysis
					v-if="outputOptions[5].include"
					:key="monitorChange + 5"
				/>
				<h3>Ethics and Dissemination</h3>
				<OutputAuditEthicsAndDissemination
					v-if="outputOptions[6].include"
					:key="monitorChange + 6"
				/>
				<h3>Contributions</h3>
				<OutputAuditContributions v-if="outputOptions[7].include" :key="monitorChange + 7" />
			</div>
			<template #footer>
				<Button
					class="btsyleblue"
					label="Copy Methods to Clipboard"
					@click="copy"
				/>
				<Button class="btsyleblue" label="Rewrite Methods" @click="reload" />
			</template>
		</Dialog>
	</div>
</template>

<script>
import OutputAuditDataCollectionManagementAndAnalysis from "./OutputAuditDataCollectionManagementAndAnalysis.vue";
import OutputAuditEthicsAndDissemination from "./OutputAuditEthicsAndDissemination.vue";
import OutputAuditPicot from "./OutputAuditPicot.vue";
import OutputAuditRecruitment from "./OutputAuditRecruitment.vue";
import OutputAuditSampleSize from "./OutputAuditSampleSize.vue";
import OutputAuditStudyInformation from "./OutputAuditStudyInformation.vue";
import OutputAuditStudySetting from "./OutputAuditStudySetting.vue";
import OutputAuditContributions from "../methods-wizard/OutputContributions.vue";

import CopyMixin from "@/mixins/CopyMixin.js";

import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Checkbox from "primevue/checkbox";

export default {
	name: "ViewMethodSearch",
	mixins: [CopyMixin],
	components: {
		Button,
		Dialog,
		Checkbox,
		OutputAuditDataCollectionManagementAndAnalysis,
		OutputAuditEthicsAndDissemination,
		OutputAuditPicot,
		OutputAuditRecruitment,
		OutputAuditSampleSize,
		OutputAuditStudyInformation,
		OutputAuditStudySetting,
		OutputAuditContributions
	},
	data() {
		return {
			monitorChange: 0,
			outputOptions: [
				{ label: "Study Information", include: true },
				{ label: "Study Setting", include: true },
				{ label: "Eligibility Criteria (PICOST)", include: true },
				{ label: "Search Strings", include: true },
				{ label: "Sample Size", include: true },
				{ label: "Recruitment", include: true },
				{ label: "Data Collection, Management and Analysis", include: true },
				{ label: "Ethics and Dissemination", include: true },
				{ label: "Contributions", include: true },
			],
			selectedOptions: [],
			displayModal: false
		};
	},
	methods: {
		openModal() {
			this.displayModal = true;
		},
		closeModal() {
			this.displayModal = false;
		},
		selectAll() {
			this.outputOptions.forEach(option => (option.include = true));
		},
		deselectAll() {
			this.outputOptions.forEach(option => (option.include = false));
		},
		reload() {
			this.monitorChange = this.monitorChange + 1;
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btsyleblue {
	margin: 10px;
	/* width: 100px; */
	background-color: #83bfed;
	border-radius: 20px;
	/* box-shadow: rgba(44, 187, 99, .2) 0 -25px 18px -14px inset, rgba(44, 187, 99, .15) 0 1px 2px, rgba(44, 187, 99, .15) 0 2px 4px, rgba(44, 187, 99, .15) 0 4px 8px, rgba(44, 187, 99, .15) 0 8px 16px, rgba(44, 187, 99, .15) 0 16px 32px; */
	color: #05305f;
	cursor: pointer;
	display: inline-block;
	font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
	padding: 7px 20px;
	text-align: center;
	text-decoration: none;
	/* transition: all 250ms; */
	border: 0;
	font-size: 16px;
}
</style>
